import type { SponsorshipMode } from '@infinex-private/connect-types';
import { ChevronDownIcon, FeeAccountFilledIcon } from '@infinex/ui-icons';
import { cn } from '@infinex/ui-styles';
import { Button, Text, ChainEmblem } from '@infinex/ui/components';

import type { UserNativeBalanceDetails } from '../../types';

interface PaymentMethodButtonProps {
  selectedPaymentMethod: SponsorshipMode;
  userBalance?: UserNativeBalanceDetails;
  onClick: () => void;
}

export function PaymentMethodButton({
  selectedPaymentMethod,
  userBalance,
  onClick,
}: PaymentMethodButtonProps) {
  return (
    <Button
      onClick={onClick}
      size="small"
      className={cn(
        'bg-surfaceTwo flex items-center gap-0.5 rounded-full px-2.5',
        'hover:bg-surfaceTwoHover cursor-pointer transition-colors'
      )}
    >
      {selectedPaymentMethod === 'account' ? (
        <>
          <FeeAccountFilledIcon size="2xsmall" />
          <Text className="text-default text-sm font-semibold">
            Gas account
          </Text>
        </>
      ) : (
        <>
          {userBalance && (
            <ChainEmblem of={userBalance.chainKey} size="xsmall" />
          )}
          <Text className="text-default text-sm font-semibold">
            {userBalance?.symbol || 'ETH'}
          </Text>
        </>
      )}
      <ChevronDownIcon size="xsmall" fill="secondary" />
    </Button>
  );
}
